import * as R from 'ramda';
import React, { useMemo } from 'react';
// components
import { Table } from '../../../components/table';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// hooks
import useEditViewHook from '../../../hooks/use-edit-view';
// feature payroll
import {
  getSortedReport,
  getExpensesReport,
  tollTableSettings,
  getDefaultReportFields,
  expensesColumnSettings,
  getRemoveRestoreColumn,
} from '../settings/charges-table-settings';
//////////////////////////////////////////////////

const ExpensesTab = (props: Object) => {
  const { type, expenses, maxHeight, selectChargeListItem, removeOrRestoreChargeListItem } = props;

  const columnSettings = R.assoc(
    'removeRestoreColumn',
    getRemoveRestoreColumn('expenses', removeOrRestoreChargeListItem),
    expensesColumnSettings,
  );

  const allChecked = G.isAllChecked(expenses);
  const tableSettings = R.assoc('maxHeight', maxHeight, tollTableSettings);

  const expensesReport = getExpensesReport(R.equals(type, GC.FIELD_DRIVER));

  const { uiReportFields, handleOpenEditView } = useEditViewHook({
    ...props,
    columnSettings,
    report: expensesReport,
    defaultReportFields: getDefaultReportFields(expensesReport),
  });

  const sortedReport = useMemo(() => (
    G.isNilOrEmpty(uiReportFields) ?
    expensesReport : getSortedReport(uiReportFields, expensesReport)
  ), [uiReportFields]);

  return (
    <Table
      itemList={expenses}
      showEditView={true}
      report={sortedReport}
      allChecked={allChecked}
      shouldUseUIFilters={true}
      useSearchableColumns={true}
      withResizableColumns={true}
      tableSettings={tableSettings}
      useNewTitleFilterInputs={true}
      columnSettings={columnSettings}
      handleClickEditOrder={handleOpenEditView}
      filterProps={G.getFilterPropsFromColumnSettings(columnSettings)}
      onOptionClick={(guid: string) => selectChargeListItem(guid, 'expenses')}
    />
  );
};

export default ExpensesTab;
